'use client';

import { useIsomorphicLayoutEffect } from '@repo/common-utils';
import { usePageNavigationEvent, useWorkingPlatform } from '@repo/platform';
import { useState } from 'react';

import { FIRST_ACCESS_PAGE_KEY } from '@/lib/constants/storage-keys';

export const useCheckHeaderShow = () => {
  const { workingPlatform } = useWorkingPlatform();
  const [isShowHeader, setIsShowHeader] = useState(true);

  useIsomorphicLayoutEffect(() => {
    setIsShowHeader(workingPlatform !== 'app' && workingPlatform !== 'care');
  }, [workingPlatform]);

  return isShowHeader;
};

export const useHeaderSelector = () => {
  const [headerType, setHeaderType] = useState('');
  const navigationEvent = usePageNavigationEvent();

  useIsomorphicLayoutEffect(() => {
    const savedPath = sessionStorage.getItem(FIRST_ACCESS_PAGE_KEY);
    const changeHeader = () => {
      const newSearchParams = new URLSearchParams(window.location.search);
      const newQueryString = newSearchParams.toString();
      const newPath = `${window.location.pathname}${newQueryString ? `?${newQueryString}` : ''}`;
      requestAnimationFrame(() => {
        setHeaderType(!savedPath || savedPath === newPath ? 'logo' : 'back');
      });
    };

    changeHeader();
    navigationEvent.registerNavigationEvent(changeHeader);

    return () => {
      navigationEvent.removeNavigationEvent(changeHeader);
    };
  }, [navigationEvent]);

  return headerType;
};
